/* eslint no-console: ["error", { allow: ["log"] }] */
import { AuthenticationLevel, hasAccess } from 'auth';
import { isElevatedLoginEnabled } from 'apps/login/utils';

const hasLoginElevatedInRavenEnabled = (user) => isElevatedLoginEnabled(user.betaFeatures);
const needsLogin = (user) => !user.authenticationLevel || user.authenticationLevel === AuthenticationLevel.PUBLIC;

export function requiredLoginLevel(loginLevel, printLogs = false) {
  return (nextState, replace, path, extras) => {
    const { store } = extras;
    const { user } = store.getState() || {};
    const targetUrl = nextState.location.pathname;

    let pathname;
    let redirect;

    if (!Object.hasOwnProperty.call(AuthenticationLevel, loginLevel)) {
      throw new Error(`[requiredLoginLevel] Invalid loginLevel argument provided: ${loginLevel}`);
    }

    if (hasAccess(user, loginLevel)) {
      if (printLogs) {
        console.log(`[requiredLoginLevel] has access to ${targetUrl}, ${loginLevel} <= ${user.authenticationLevel}`);
      }

      return true;
    }

    if (printLogs) {
      console.log(
        `[requiredLoginLevel] no access to ${targetUrl} redirecting, ${loginLevel} <= ${user.authenticationLevel}`
      );
    }
    if (needsLogin(user)) {
      pathname = '/login';
      redirect = 'redirect';
    } else if (hasLoginElevatedInRavenEnabled(user)) {
      pathname = '/login-elevated';
      redirect = 'redirect';
    } else {
      pathname = '/webshop/loginElevated.go';
      redirect = 'success_redirect';
    }
    if (printLogs) console.log(`[requiredLoginLevel] redirecting to ${pathname}`);

    replace({
      pathname,
      query: {
        [redirect]: targetUrl,
      },
    });

    return false;
  };
}
